"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _currency = require("@nerdwallet/currency");
var _controlStatements = require("./control-statements");
var _utils = require("./lib/utils");
var BaseOptionalListContent = function BaseOptionalListContent(_ref) {
  var className = _ref.className,
    content = _ref.content,
    contentLabel = _ref.contentLabel;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !(0, _isEmpty2.default)(content) ? /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    bold: true
  }, contentLabel), content) : null);
};
var OptionalListContent = function OptionalListContent(_ref2) {
  var className = _ref2.className,
    content = _ref2.content,
    contentLabel = _ref2.contentLabel,
    _ref2$useLiPadding = _ref2.useLiPadding,
    useLiPadding = _ref2$useLiPadding === void 0 ? false : _ref2$useLiPadding;
  return /*#__PURE__*/_react.default.createElement(BaseOptionalListContent, {
    className: className,
    content: (0, _isArray2.default)(content) ? /*#__PURE__*/_react.default.createElement(_currency.List, null, content.map(function (listBullet) {
      var _listBullet$id, _listBullet$bullet;
      return /*#__PURE__*/_react.default.createElement(_currency.Li, {
        key: "bullet-".concat((0, _kebabCase2.default)((_listBullet$id = listBullet === null || listBullet === void 0 ? void 0 : listBullet.id) !== null && _listBullet$id !== void 0 ? _listBullet$id : listBullet)),
        className: (0, _classes.default)({
          'margin-bottom-2': useLiPadding
        })
      }, (0, _utils.sanitizeNode)((_listBullet$bullet = listBullet === null || listBullet === void 0 ? void 0 : listBullet.bullet) !== null && _listBullet$bullet !== void 0 ? _listBullet$bullet : listBullet));
    })) : (0, _utils.sanitizeNode)(content),
    contentLabel: contentLabel
  });
};
var _default = OptionalListContent;
exports.default = _default;